export default __webpack_public_path__ + "static/media/trust.2a725d5d.svg";